<template>
  <div class="taskClock-edit">
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <div class="white-container">
        <el-form-item label="标题" prop="title" style="width: 460px">
          <el-input v-model="form.title" maxlength="14" placeholder="请输入任务标题，最多不超过14个字符" />
        </el-form-item>
        <el-form-item label="报名日期" prop="registrationTime" style="width: 460px">
          <el-date-picker v-model="form.registrationTime" type="daterange" start-placeholder="报名开始日期" end-placeholder="报名结束日期" value-format="yyyy-MM-dd" @change="handleTimeChange" />
        </el-form-item>
        <el-form-item label="打卡任务" prop="taskList">
          <TaskList ref="taskList" :task-data="taskData" @change="handleTaskChange" />
        </el-form-item>
        <el-form-item label="运动目标" prop="movingTarget" style="width:300px">
          <el-select v-model="form.movingTarget" placeholder="请选择运动目标" multiple :disabled="disabled">
            <el-option v-for="item in movingSelectVO" :key="item.id" :label="item.tagName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="任务介绍" prop="taskIntroduction" style="width: 100%">
          <el-input v-model="form.taskIntroduction" type="textarea" placeholder="请输入任务介绍" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="注意事项" prop="announcement" style="width: 100%">
          <el-input v-model="form.announcement" type="textarea" placeholder="请输入注意事项" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="小结文案" prop="summaryCopy" style="width: 100%">
          <el-input v-model="form.summaryCopy" type="textarea" placeholder="请输入小结文案" :disabled="disabled" />
        </el-form-item>
        <el-form-item label="抽奖ID" prop="crmLotteryId" style="width: 460px">
          <el-input v-model="form.crmLotteryId" maxlength="255" placeholder="请输入活动id" />
        </el-form-item>
      </div>
      <div class="white-container marginTop">
        <el-form-item label="上传图片" prop="taskImage" class="image-config">
          <div class="flex uploadImg-cont" style="flex-wrap: wrap">
            <!-- <UploadImage :disabled="disabled" :url="form.taskImage.listPictures" title="列表页图片" :save-path="savePath" size-tips="686px*240px" @triggerReg="handleCheckReg" @upload="data => (form.taskImage.listPictures = data)" /> -->
            <UploadImage :url="form.taskImage.taskDetailsPageHeader" title="任务详情页头图" size-tips="1125px*1125px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'taskDetailsPageHeader')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.taskImage.taskShareCardImage" title="小程序分享卡片" size-tips="500px*400px" :limit-size="2" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'taskShareCardImage')" @triggerReg="handleCheckReg" />
            <UploadImage :url="form.taskImage.taskShareImage" title="任务长图分享图片" size-tips="849px*849px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'taskShareImage')" @triggerReg="handleCheckReg" />
            <UploadImage :disabled="disabled" :url="form.taskImage.myMatchListPictures" title="我的运动列表页图片" :save-path="savePath" size-tips="360px*576px" @triggerReg="handleCheckReg" @upload="data => (form.taskImage.myMatchListPictures = data)" />
            <UploadImage :url="form.taskImage.bannerDiagramOfBottomCommunity" title="底部社群banner图" size-tips="1005px*335px" :save-path="savePath" :disabled="disabled" @upload="uploader($event,'bannerDiagramOfBottomCommunity')" @triggerReg="handleCheckReg" />
          </div>
        </el-form-item>
        <el-form-item style="width:100%;margin-top:80px;margin-left:-50px">
          <div class="flex btns">
            <el-button type="info" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSave">保存</el-button>
          </div>
        </el-form-item>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />

  </div>

</template>

<script>
import { TaskClock } from '@/model/TaskClock';
import TaskList from './taskList.vue';
import Dialog from '@/components/Dialog';
import { mapActions, mapState } from 'vuex';
import UploadImage from '@/components/UploadImage';
import { postAddTaskActivity, postUpdateTaskActivity, createTaskClock, updateTaskClock } from '@/api/taskClock';
export default {
  components: { TaskList, Dialog, UploadImage },
  data() {
    return {
      savePath: 'taskClock/detail/',
      form: new TaskClock(),
      rules: {
        title: [
          { required: true, message: '请输入任务标题', trigger: 'blur' },
        ],
        registrationTime: [
          { type: 'array', required: true, message: '请选择报名日期', trigger: 'change' },
        ],
        taskList: {
          required: true, validator: (rule, value, callback) => {
            const keys = ['course', 'taskBodyTestDetailsVOS', 'uaEvent', 'userDefinedTaskDetailVOS', 'running'];
            let totalLength = 0;
            keys.forEach(key => {
              if (value.hasOwnProperty(key) && Array.isArray(value[key])) {
                totalLength += value[key].length;
              }
            });
            if (totalLength === 0) {
              callback(new Error('请至少添加一个打卡任务'));
            }
            if (!value) {
              callback(new Error('请添加打卡任务'));
            } else {
              callback();
            }
          }, trigger: ['blur', 'change'],
        },
        movingTarget: [
          { type: 'array', required: true, message: '请选择运动目标', trigger: 'change' },
        ],
        taskIntroduction: [
          { required: true, message: '请输入任务介绍', trigger: 'blur' },
        ],
        announcement: [
          { required: true, message: '请输入注意事项', trigger: 'blur' },
        ],
        summaryCopy: [
          { required: true, message: '请输入小结文案', trigger: 'blur' },
        ],
        taskImage: {
          required: true, validator: (rule, value, callback) => {
            const keys = [
              { key: 'taskDetailsPageHeader', label: '任务详情页头图' },
              { key: 'taskShareCardImage', label: '小程序分享卡片' },
              { key: 'taskShareImage', label: '任务长图分享图片' },
              { key: 'myMatchListPictures', label: '我的运动列表页图片' },
              { key: 'bannerDiagramOfBottomCommunity', label: '底部社区banner图' },
            ];
            for (const { key, label } of keys) {
              if (!value[key]) {
                callback(new Error(`请上传${label}`));
              }
            }
            callback();
          }, trigger: ['change'],
        },
      },
      taskNumVisible: false,
      formDialogShow: false,
      information: {},
      cancelText: '',
      taskData: {},
      daysList: [],
      duration: 0,
      lottery: false,
    };
  },
  computed: {
    ...mapState('camp',
      [
        'movingSelectVO',
      ]),
    disabled() {
      // return [0, 2, 4].indexOf(this.form.status) !== -1;
      return false;
    },

  },
  async mounted() {
    await this.getSelect();
    const { query } = this.$route;
    this.lottery = query.lottery === 'true';
    if (query.id) {
      this.form.id = query.id;
      this.cancelText = "编辑";
      await this.getDetail(query.id);
      await this.fetchTaskList(query.id);
    } else {
      console.info("新增");
      this.cancelText = "新增";
    }
  },
  methods: {
    ...mapActions('camp', ['getSelect']),
    handleTimeChange(e) {
      if (e?.length === 2) {
        this.form.taskDateTime = e;
      } else {
        this.form.taskDateTime = [];
      }
    },
    async getDetail(id) {
      const res = await this.$Api.taskClock.taskActivityDetails(id);
      if (res) {
        this.form = new TaskClock(res);
        this.duration = this.form.duration ? Number(this.form.duration) : 0;
      }
    },
    // 获取打卡任务列表
    async fetchTaskList(id) {
      const res = await this.$Api.taskClock.getTaskList(9, id);
      if (res) {
        this.taskData = res;
      }
    },
    handleCheckReg() {
      this.$refs.form.validateField("taskImage");
    },
    uploader(file, key) {
      this.form.taskImage = {
        ...this.form.taskImage,
        [key]: file,
      };
    },
    handleTaskChange(data) {
      this.form.taskList = data;
      this.$refs.form.validateField("taskList");
    },
    handleSave() {
      this.formDialogShow = true;
      this.information = {
        operation: "submit",
        icon: "warn",
        subTitle: "请注意打卡任务状态，保存后已发布的打卡任务信息将实时更新至UA HOUSE小程序",
      };
    },
    handleCancel() {
      this.formDialogShow = true;
      this.information = {
        operation: 'delete',
        icon: 'warn',
        subTitle: `是否放弃${this.cancelText}，返回上级页面？`,
      };
    },
    dialogSuccess() {
      if (this.information.operation && this.information.operation === 'delete') {
        this.goBack();
      } else if (this.information.operation && this.information.operation === 'submit') {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.cancelText === "新增") {
              this.form.formatForm();
              postAddTaskActivity(this.form).then(res => {
                if (res) {
                  const taskParams = this.dealTaskActivity(res);
                  createTaskClock(taskParams).then(data => {
                    this.$message.success('新增成功');
                    this.$router.push('/online_activity/taskClock');
                  });
                }
              });
            } else {
              this.form.formatForm();
              postUpdateTaskActivity(this.form).then(res => {
                const taskParams = this.dealTaskActivity(this.form.id);
                updateTaskClock(taskParams).then(data => {
                  this.$message.success('修改成功');
                  this.$router.push('/online_activity/taskClock');
                });
              });
            }
          } else {
            return false;
          }
        });
      }
    },
    dealTaskActivity(id) {
      const data = {
        objectType: 9,
        objectId: id,
      };
      const keys = ['course', 'taskBodyTestDetailsVOS', 'uaEvent', 'userDefinedTaskDetailVOS','running'];
      let totalLength = 0;
      keys.forEach(key => {
        if (this.form.taskList.hasOwnProperty(key) && Array.isArray(this.form.taskList[key])) {
          totalLength += this.form.taskList[key].length;
        }
      });
      if (totalLength === 0) {
        console.info('这一天没有任务');
      } else {
        const obj = {
          courseId: this.form.taskList.course.map(c => c.id),
          uaEventId: this.form.taskList.uaEvent.map(u => u.id),
          userDefinedTaskAddDTOS: this.form.taskList.userDefinedTaskDetailVOS || [],
          taskBodyTestAddDTOS: this.form.taskList.taskBodyTestDetailsVOS || [],
          runningId: this.form.taskList.running.map(r => r.id)
        };
        data['trainingCampTaskDTOS'] = obj;
      }
      return data;
    },
    goBack() {
      this.$router.back(-1);
    },
  },
};
</script>
<style lang="less">
.el-tooltip__popper.is-dark.num_atooltip {
  margin-left: 30px;
  background: #f7f7f7;
  color: #494949;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.17);
  > .popper__arrow,
  > .popper__arrow::after {
    border-right-color: #f7f7f7 !important;
  }
  > .popper__arrow {
    border-right-color: rgba(0, 0, 0, 0.07) !important;
  }
}
</style>
<style lang="less" scoped>
.form-radio {
  > .num {
    position: relative;
    width: 304px;
    margin-top: 20px;
    /deep/.el-input__inner {
      height: 34px;
    }
    /deep/.el-input__suffix {
      right: 15px;
      > .el-input__suffix-inner {
        height: 100%;
        display: flex;
        align-items: center;
        > img {
          width: 14px;
          height: 14px;
          cursor: pointer;
          user-select: none;
        }
      }
    }
  }
}
.marginTop {
  margin-top: 20px;
}
.flex > div {
  margin-bottom: 30px;
}
.btns {
  align-items: center;
  justify-content: center;
}
.lotteryDisabled {
  cursor: not-allowed;
}
.lottery-context {
  pointer-events: none;
}
.lotteryDisabled:hover:after {
  position: absolute;
  margin-left: 48px;
  padding: 2px 10px;
  box-shadow: 0 2px 9px #999;
  background-color: #fff;
  border-radius: 4px;
  color: #666;
  content: attr(title);
  z-index: 2;
  line-height: 20px;
  height: 20px;
}
</style>
